import { combineReducers } from '@reduxjs/toolkit';

import settingsDialogReducer from './settingsDialogReducer';
import themeReducer from './themeReducer';

/**
 * Combined reducer for the core domain
 */
const coreReducer = combineReducers({
  settingsDialog: settingsDialogReducer,
  theme: themeReducer,
});

export default coreReducer;
